
















































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { ArticolazioneInfo } from "../../_models/articolazioneInfo";

@Component
export default class EditUserRoles extends Vue {
  @Prop() info!: any;

  private items: any[];

  private roles: number[];
  private rolesList: object;
  private ruoloRules: [boolean | string];
  private newRole: number;
  private changedRole: number;
  private username: string;
  private idUtente: number;
  private articolazioni: any;
  private indirizziStudio: any;
  private changedArticolazione: string;

  private settore: number;
  // private articolazione: string;

  private showNewRole: boolean;
  private showNewArticolazione: boolean;
  private modifySettore: boolean;
  private modifyArticolazione: boolean;
  private modifyRole: boolean;

  private isAdmin: boolean; //true se utente selezionato è admin

  constructor() {
    super();
    this.items = [];
    this.roles = this.info.ruoloUtente;
    this.ruoloRules = [true];
    this.rolesList = [];
    this.newRole = 0;
    this.changedRole = 0;
    this.username = this.info.username;
    this.idUtente = this.info.idUtente;
    this.articolazioni = [];
    this.indirizziStudio = [];
    this.changedArticolazione = "";

    this.settore = 0;
    // this.articolazione = "";

    this.showNewRole = false;
    this.showNewArticolazione = false;
    this.modifySettore = false;
    this.modifyArticolazione = false;
    this.modifyRole = false;

    this.isAdmin = false;
  }

  // @Watch('items')
  // onItemsChange(value: any){
  //   this.items = value

  // }

  validazioneRuolo() {
    if (this.newRole === 0) {
      this.ruoloRules = ["Ruolo utente necessario"];
    } else {
      this.ruoloRules = [true];
    }
  }

  validazioneRuolo2() {
    if (this.changedRole === 0) {
      this.ruoloRules = ["Ruolo utente necessario"];
    } else {
      this.ruoloRules = [true];
    }
  }

  async executeTest() {
    this.validazioneRuolo();
  }

  async executeTest2() {
    this.validazioneRuolo2();
  }

  deleteAssegnazioneArticolazione(assegnazione: string) {
    var payload = {
      idUtente: this.idUtente,
      idArticolazione: assegnazione
    };
    user
      .dispatchdDeleteAssegnazioneArticolazione(this["$store"], payload)
      .then(() => {
        bus.$emit(
          "successfullOperation",
          "Associazione articolazione cancellata con successo"
        );
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  changeAssegnazioneArticolazione(index: number, item: string) {
    // this.modifyArticolazione = true;
    var id = "articolazione_" + String(index);
    var idItem = item;
    let chageBlock = document.getElementById(id);
    let itemBlock = document.getElementById(idItem);
    if (chageBlock !== null) {
      chageBlock.classList.remove("hidden");
    }
    if (itemBlock !== null) {
      itemBlock.classList.add("hidden");
    }
    // this.changedArticolazione = "";
    this.modifyArticolazione = true;
  }

  closeAssegnazioneArticolazione(index: number, item: string) {
    // this.modifyArticolazione = false;
    var id = "articolazione_" + String(index);
    var idItem = item;
    let chageBlock = document.getElementById(id);
    let itemBlock = document.getElementById(idItem);
    if (chageBlock !== null) {
      chageBlock.classList.add("hidden");
    }
    if (itemBlock !== null) {
      itemBlock.classList.remove("hidden");
    }
    this.changedArticolazione = "";
    this.modifyArticolazione = false;
  }

  confirmAssegnazioneArticolazione(oldArticolazione: string) {
    var payload = {
      idUtente: this.idUtente,
      idArticolazione: this.changedArticolazione,
      idOldArticolazione: oldArticolazione
    };
    user
      .dispatchConfirmAssegnazioneArticolazione(this["$store"], payload)
      .then(() => {
        bus.$emit(
          "successfullOperation",
          "Associazione articolazione aggiunta con successo"
        );
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  deleteAssegnazioneSettore(assegnazione: number) {
    var payload = {
      idUtente: this.idUtente,
      idIndirizzoStudio: assegnazione
    };
    user
      .dispatchDeleteAssegnazioneIndirizzoStudio(this["$store"], payload)
      .then(() => {
        bus.$emit(
          "successfullOperation",
          "Associazione settore cancellata con successo"
        );
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  addArticolazione() {
    this.showNewArticolazione = true;
  }

  closeAddArticolazione() {
    this.showNewArticolazione = false;
  }

  changeAssegnazioneSettore() {
    this.modifySettore = true;
  }

  closeAssegnazioneSettore() {
    this.modifySettore = false;
  }

  confirmAssegnazioneSettore(oldSettore: number) {
    var payload = {
      idUtente: this.idUtente,
      idIndirizzoStudio: this.settore,
      idOldIndirizzoStudio: oldSettore
    };
    user
      .dispacthConfirmAssegnazioneIndirizzoStudio(this["$store"], payload)
      .then(() => {
        bus.$emit(
          "successfullOperation",
          "Associazione settore aggiunta con successo"
        );
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  changeRole(index: number, item: number) {
    var id = String(index);
    var idItem = String(item);
    let chageBlock = document.getElementById(id);
    let itemBlock = document.getElementById(idItem);
    if (chageBlock !== null) {
      chageBlock.classList.remove("hidden");
    }
    if (itemBlock !== null) {
      itemBlock.classList.add("hidden");
    }
    this.modifyRole = true;
  }

  closeChangeRole(index: number, item: number) {
    var id = String(index);
    var idItem = String(item);
    let chageBlock = document.getElementById(id);
    let itemBlock = document.getElementById(idItem);
    if (chageBlock !== null) {
      chageBlock.classList.add("hidden");
    }
    if (itemBlock !== null) {
      itemBlock.classList.remove("hidden");
    }
    this.changedRole = 0;
    this.modifyRole = false;
  }

  confirmChangeRole(index: number, role: number) {
    var payload = {
      username: "",
      newRole: 0,
      oldRole: role
    };
    this.executeTest2().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        payload.username = this.username;
        payload.newRole = this.changedRole;
        user
          .dispatchUpdateUserRole(this["$store"], payload)
          .then(() => {
            bus.$emit("successfullOperation", "Ruolo modificato con successo");
            // this.loadRuoli();
            Vue.set(this.items, index, {
              role: this.changedRole,
              assegnazione: 0
            });
            this.closeChangeRole(index, role);
            // this.loadRuoli();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      }
    });
  }

  closeNewRole() {
    this.showNewRole = false;
  }

  addRole() {
    this.showNewRole = true;
  }

  confirmNewRole() {
    var payload = {
      username: "",
      newRole: 0
    };
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        payload.username = this.username;
        payload.newRole = this.newRole;
        user
          .dispatchAddUserRole(this["$store"], payload)
          .then(() => {
            bus.$emit("successfullOperation", "Ruolo aggiunto con successo");
            this.roles.push(payload.newRole);
            this.items.push({ role: payload.newRole, assegnazione: 0 });
            this.closeNewRole();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      }
    });
  }

  deleteRole(role: number, index: number) {
    var payload = {
      username: this.username,
      role: role,
      idUtente: this.info.idUtente
    };

    // var payload2 = {
    //   idUtente: this.info.idUtente
    // };
    var userInfo = user.readUserInfo(this["$store"]);
    if (this.roles.length - 1 === 0) {
      bus.$emit("errorOperation", "L'utente deve avere almeno un ruolo");
    } else {
      // if (userInfo.tipoSoggetto === 2) {
      user
        .dispatchDeleteUserRole(this["$store"], payload)
        .then(() => {
          bus.$emit("successfullOperation", "Ruolo cancellato con successo");
          this.$delete(this.items, index);
          // this.loadRuoli();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
      // }

      // else {
      //   console.log("azienda");
      // }
    }
  }

  close() {
    this.showNewRole = false;
    this.modifySettore = false;
    this.modifyArticolazione = false;
    bus.$emit("closeEditDialog");
    bus.$emit("loadUserList");
  }

  loadRuoli() {
    var indirizzi: any[] = [];
    var item: {
      role: number;
      assegnazione: number;
    };
    var userInfo = user.readUserInfo(this["$store"]);
    this.items = [];
    this.roles = this.info.ruoloUtente;
    this.ruoloRules = [true];
    this.rolesList = [];
    this.newRole = 0;
    this.changedRole = 0;
    this.username = this.info.username;
    this.idUtente = this.info.idUtente;
    this.articolazioni = [];
    this.indirizziStudio = [];
    this.changedArticolazione = "";

    this.settore = 0;

    this.showNewRole = false;
    this.showNewArticolazione = false;
    this.modifySettore = false;
    this.modifyArticolazione = false;
    this.modifyRole = false;
    if (userInfo.tipoSoggetto === 2) {
      //istituto
      var settore: {
        role: number;
        assegnazione: number;
      };
      var art: {
        role: number;
        assegnazione: ArticolazioneInfo[];
      };
      var indirizzo = {
        idIndirizzo: 0,
        nomeIndirizzo: ""
      };
      var articolazione = {
        idArticolazione: "",
        nomeArticolazione: ""
      };
      var instituteInfo = user.readInstituteInfo(this["$store"]);
      this.rolesList = [
        { ruolo: "Tutor Settore", idRuolo: 5 },
        { ruolo: "Tutor Articolazione", idRuolo: 6 },
        { ruolo: "Tutor Formativo", idRuolo: 10 },
        { ruolo: "Osservatore", idRuolo: 11 }
      ];
      item = {
        role: 0,
        assegnazione: 0
      };

      this.roles.forEach(role => {
        if (role === 5) {
          data
            .dispatchAssegnazioneIndirizzoStudio(
              this["$store"],
              this.info.idUtente
            )
            .then(resp => {
              settore = {
                role: role,
                assegnazione: resp
              };
              this.items.push(settore);
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        } else if (role === 6) {
          data
            .dispatchAssegnazioneArticolazione(
              this["$store"],
              this.info.idUtente
            )
            .then(resp => {
              art = {
                role: role,
                assegnazione: resp
              };
              this.items.push(art);
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        } else if (role === 2) {
          item = {
            role: role,
            assegnazione: 0
          };
          this.items.push(item);
        } else if (role === 10 || role === 11) {
          item = {
            role: role,
            assegnazione: 0
          };
          this.items.push(item);
        }
      });
      data
        .dispatchListaIndirizziStudi(this["$store"], instituteInfo.id)
        .then(response => {
          response.forEach(function(element: any) {
            indirizzo = {
              idIndirizzo: element.Id,
              nomeIndirizzo:
                element.NomeSettore + " INDIRIZZO " + element.NomeIndirizzo
            };
            indirizzi.push(indirizzo);
          });
          this.indirizziStudio = indirizzi;
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
      data
        .dispatchArticolazioni(this["$store"], instituteInfo.id)
        .then(response => {
          response.forEach(element => {
            articolazione = {
              idArticolazione: element.idArticolazione,
              nomeArticolazione: element.nomeArticolazione
            };
            this.articolazioni.push(articolazione);
          });
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      //azienda
      this.rolesList = [
        { ruolo: "Tutor Aziendale", idRuolo: 7 },
        { ruolo: "Referente HR Azienda", idRuolo: 8 },
        { ruolo: "Selezionatore", idRuolo: 9 }
      ];
      item = {
        role: 0,
        assegnazione: 0
      };
      this.roles.forEach(role => {
        item = {
          role: role,
          assegnazione: 0
        };
        if (role === 3) {
          this.isAdmin = true;
        }
        this.items.push(item);
      });
    }
  }

  created() {
    // var indirizzi: any[] = [];
    // var articolazioni: any[] = [];
    this.loadRuoli();
  }
}
